import { Card, css, MAGNETIC_TOKENS, Tooltip } from '@appd/uik';
import React from 'react';

const {
  TYPOGRAPHY: { P3_DEFAULT, P1_BOLD, ELLIPSES },
  COLORS: { DEFAULT_TEXT_MEDIUM },
} = MAGNETIC_TOKENS;

type Props = {
  title: string;
  value: string;
  icon?: string;
  comparisonText?: string;
  className?: string;
};

export function BusinessJourneyStatisticsCard({ title, value, icon, comparisonText, className }: Props): JSX.Element {
  return (
    <Card className={css({ height: '92px' }, className)}>
      <Tooltip showOnOverflowOnly value={title}>
        <div className={css({ ...ELLIPSES.END, font: P3_DEFAULT, color: DEFAULT_TEXT_MEDIUM })}>{title}</div>
      </Tooltip>
      <p className={css({ font: P1_BOLD, margin: 0 })}>{value}</p>
    </Card>
  );
}
